import { a as _slicedToArray, d as _objectSpread2, n as _defineProperty } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Slider from './Slider.js';
import Modal from './Modal.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import 'rc-slider/lib/Slider';
import './index-11bc5ac3.js';
import './_commonjsHelpers-17042db9.js';
import './Button-a16585e5.js';
import './utilsHelpers-e4b21f4b.js';
import 'react-dom';
import './ModalHeader-77a50105.js';
import './Title.js';
import './tslib.es6-2748fcb6.js';
import 'moment';

var RadioOption = function RadioOption(_ref) {
  var name = _ref.name,
    disabled = _ref.disabled,
    option = _ref.option,
    selectedOption = _ref.selectedOption,
    onChange = _ref.onChange,
    setSelectedOption = _ref.setSelectedOption;
  var checked = option.checked,
    description = option.description,
    optionDisabled = option.disabled,
    extraDetails = option.extraDetails,
    modalInfo = option.modalInfo,
    value = option.value;
  var onClick = useCallback(function () {
    if (!disabled && !option.disabled) {
      onChange(option);
      setSelectedOption(option.value);
    }
  }, [disabled, option, onChange, setSelectedOption]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-radio-option"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    name: name,
    disabled: disabled || optionDisabled,
    defaultChecked: checked || selectedOption === value,
    value: value,
    id: value,
    readOnly: true
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "bf-radio-label",
    htmlFor: option.value,
    onClick: onClick
  }, option.content, /*#__PURE__*/React__default.createElement("br", null), description ? /*#__PURE__*/React__default.createElement("span", {
    className: "description"
  }, description) : null), (extraDetails === null || extraDetails === void 0 ? void 0 : extraDetails.length) ? /*#__PURE__*/React__default.createElement(Modal, {
    trigger: /*#__PURE__*/React__default.createElement("span", {
      className: "link-style margin-left-small"
    }, modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.triggerText),
    title: modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.title,
    content: /*#__PURE__*/React__default.createElement("table", {
      className: "panel-table"
    }, /*#__PURE__*/React__default.createElement("tbody", null, extraDetails.map(function (extraDetail, index) {
      var itemKey = "extra_detail_item_".concat(index);
      return /*#__PURE__*/React__default.createElement("tr", {
        key: itemKey
      }, /*#__PURE__*/React__default.createElement("td", null, extraDetail.description), /*#__PURE__*/React__default.createElement("td", {
        className: "align-right"
      }, extraDetail.amount, ' USD'));
    })), /*#__PURE__*/React__default.createElement("tfoot", {
      className: "remove-horizontal-padding"
    }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.total), /*#__PURE__*/React__default.createElement("td", {
      className: "align-right"
    }, extraDetails.reduce(function (acum, detail) {
      return acum + detail.amount;
    }, 0), ' USD')))),
    size: "tiny",
    inlineTrigger: true,
    className: "margin-left-small"
  }) : null);
};
RadioOption.defaultProps = {
  selectedOption: ''
};
RadioOption.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  option: PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.object)]),
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    extraDetails: PropTypes.arrayOf(PropTypes.shape({
      description: PropTypes.string,
      amount: PropTypes.number
    })),
    modalInfo: PropTypes.shape({
      triggerText: PropTypes.string,
      title: PropTypes.string,
      total: PropTypes.string
    }),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.object)])
  }).isRequired,
  selectedOption: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  setSelectedOption: PropTypes.func.isRequired
};

function Radio(props) {
  var name = props.name,
    label = props.label,
    required = props.required,
    disabled = props.disabled,
    onChange = props.onChange,
    options = props.options,
    className = props.className,
    showError = props.showError,
    errorMessage = props.errorMessage,
    isSlider = props.isSlider,
    defaultSelectedId = props.defaultSelectedId,
    showButtons = props.showButtons;
  var _useState = useState("".concat(defaultSelectedId, "_").concat(name)),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var onChangeSlider = useCallback(function (value) {
    return options.forEach(function (_ref, index) {
      var step = _ref.slider.step;
      if (step === value && options[index]) {
        onChange(options[index]);
        setSelectedOption(options[index].value);
      }
    });
  }, [options, onChange]);
  var radioWrapperClasses = "bf-form-element-wrapper\n        bf-radio-wrapper\n        ".concat(required ? 'bf-form-element-is-required' : '', "\n        ").concat(disabled ? 'bf-form-element-is-disabled' : '', "\n        ").concat(showError ? 'bf-form-element-has-error' : '', "\n        ").concat(className, "\n    ");
  var buildSlider = useMemo(function () {
    return function () {
      var _options$slider, _options$0$slider;
      var maxStep = (_options$slider = options[options.length - 1].slider) === null || _options$slider === void 0 ? void 0 : _options$slider.step;
      var minStep = (_options$0$slider = options[0].slider) === null || _options$0$slider === void 0 ? void 0 : _options$0$slider.step;
      var marks = options.reduce(function (acc, _ref2) {
        var step = _ref2.slider.step;
        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, step, "".concat(step, "%")));
      }, {});
      var optionSelected = options.find(function (option) {
        return option.value === selectedOption;
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Slider, {
        marks: marks,
        onChange: onChangeSlider,
        min: minStep,
        max: maxStep,
        disabled: !optionSelected || !(optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.checked),
        options: options,
        selectedOption: selectedOption,
        showButtons: showButtons
      }), /*#__PURE__*/React__default.createElement(RadioOption, {
        name: name,
        option: optionSelected || options[defaultSelectedId],
        disabled: disabled,
        selectedOption: selectedOption,
        onChange: onChange,
        setSelectedOption: setSelectedOption
      }));
    };
  }, [defaultSelectedId, disabled, name, onChange, onChangeSlider, options, selectedOption, showButtons]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: radioWrapperClasses
  }, label ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-form-element-label"
  }, label)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-radio-options-wrapper"
  }, isSlider ? buildSlider() : options.map(function (option, index) {
    var key = "OPTION_".concat(index);
    return /*#__PURE__*/React__default.createElement(RadioOption, {
      name: name,
      disabled: disabled,
      option: option,
      selectedOption: selectedOption,
      onChange: onChange,
      setSelectedOption: setSelectedOption,
      key: key
    });
  })), showError && errorMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-error-message"
  }, errorMessage) : null);
}
Radio.defaultProps = {
  required: false,
  disabled: false,
  label: '',
  name: '',
  className: '',
  showError: false,
  errorMessage: '',
  onChange: null,
  isSlider: false,
  showButtons: false
};
Radio.propTypes = {
  /**
  Set as required to be selected
   */
  required: PropTypes.bool,
  /**
  Radio group can have disabled state
   */
  disabled: PropTypes.bool,
  /**
  Radio group name attr
   */
  name: PropTypes.string,
  /**
  Radio group label text
   */
  label: nodeOrStringProp,
  /**
  Radio options
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.object)]),
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    slider: PropTypes.shape({
      step: PropTypes.number
    })
  })).isRequired,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Show Radio with error status
   */
  showError: PropTypes.bool,
  /**
  Error message on error status
   */
  errorMessage: nodeOrStringProp,
  /**
  Radio group onChange callback
   */
  onChange: PropTypes.func,
  /**
  Show Radio group as slider
   */
  isSlider: PropTypes.bool,
  /**
  Default radio selected
   */
  defaultSelectedId: PropTypes.number.isRequired,
  /**
  Show buttons
   */
  showButtons: PropTypes.bool
};

export default Radio;
//# sourceMappingURL=Radio.js.map
